export type NotificationItem = {
  id: string;
  type: "success" | "error";
  title: string;
  description?: string;
  // Nút trong toast (vd "Hoàn tác" sau khi xếp lịch hàng loạt) — bấm xong tự đóng
  actions?: NotificationAction[];
};

export type NotificationAction = { label: string; onClick: () => void };

type Listener = (items: NotificationItem[]) => void;

class NotifyStore {
  private items: NotificationItem[] = [];
  private listeners = new Set<Listener>();

  subscribe(fn: Listener) {
    this.listeners.add(fn);
  }

  unsubscribe(fn: Listener) {
    this.listeners.delete(fn);
  }

  push(type: NotificationItem["type"], title: string, description?: string, opts?: { actions?: NotificationAction[]; durationMs?: number }) {
    const id = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
    this.items = [...this.items, { id, type, title, description, actions: opts?.actions }];
    this.emit();
    setTimeout(() => this.dismiss(id), opts?.durationMs ?? 4500);
  }

  dismiss(id: string) {
    this.items = this.items.filter((n) => n.id !== id);
    this.emit();
  }

  private emit() {
    this.listeners.forEach((fn) => fn([...this.items]));
  }
}

export const notifyStore = new NotifyStore();

export const notify = {
  success: (title: string, description?: string, opts?: { actions?: NotificationAction[]; durationMs?: number }) =>
    notifyStore.push("success", title, description, opts),
  error: (title: string, description?: string) =>
    notifyStore.push("error", title, description),
};
